import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 21" {...props}>
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width={0.688}
      d="M14.36 20c.17 0 .328-.048.471-.145a.744.744 0 0 0 .323-.515.719.719 0 0 0-.135-.594l-5.941-8.24 5.941-8.253a.705.705 0 0 0 .135-.594.783.783 0 0 0-.323-.515.808.808 0 0 0-.605-.132.786.786 0 0 0-.524.33l-5.62 7.79-5.618-7.79a.748.748 0 0 0-.524-.33.826.826 0 0 0-.605.132.783.783 0 0 0-.323.515.772.772 0 0 0 .134.594l5.956 8.253-5.956 8.24a.789.789 0 0 0-.134.594c.036.22.143.392.323.515a.82.82 0 0 0 .47.145c.278 0 .497-.11.659-.33l5.619-7.804 5.619 7.804c.161.22.38.33.659.33Zm17.833 0a.774.774 0 0 0 .565-.224.768.768 0 0 0 0-1.123.774.774 0 0 0-.565-.224H23.47V1.896a.747.747 0 0 0-.228-.554.78.78 0 0 0-.565-.238.796.796 0 0 0-.578.238.747.747 0 0 0-.229.554v17.312c0 .22.077.41.229.568a.82.82 0 0 0 .578.224h9.517Z"
    />
  </svg>
);
export const OversizedIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
